import {GET_MATERINITY_DIS_DOCS} from "../../../enums/Request/request.types";

export const getMaterinityDisDocsAction =  (data) => {
    return {
        type: GET_MATERINITY_DIS_DOCS,
        payload: data,
    };
};
